// extracted by mini-css-extract-plugin
module.exports = {"badge":"NotificationBadge_badge__2CKdv","window":"NotificationBadge_window__1CapB","content":"NotificationBadge_content__3zZTC","BLUE":"NotificationBadge_BLUE__2OeCM"};